
import * as angular from "angular";

import "./horizontalBarChart.scss";

interface IHorizontalBarChartBindings {
    percentage: number;
    value: number;
    maxValue: number;
    className: string;
    showValue: boolean;
}

class HorizontalBarChartComponentController implements angular.IComponentController, IHorizontalBarChartBindings {
    percentage: number;

    value: number;
    maxValue: number;
    className: string;
    showValue: boolean;

    static $inject = [];

    constructor() {
    }

    $onInit(): void {
        this.maxValue = 100;
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {

        if (onChangesObj["value"] && this.value || onChangesObj["maxValue"] && this.maxValue) {
            this.percentage = this.value * 100 / this.maxValue;
            this.percentage = Math.min(100, this.percentage);
        }
    }
}

export class HorizontalBarChartComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    transclude: boolean | { [index: string]: string; };

    constructor() {
        this.bindings = {
            percentage: "<",
            value: "<",
            maxValue: "<",
            className: "@",
            showValue: "<"
        };

        this.transclude = true;
        this.controller = HorizontalBarChartComponentController;
        this.template = require("./horizontalBarChart.html");
    }
}
